<template>
  <div class="hello">
        
      <div class="page">
 
        <div class="bg"></div><div class="bg bg2"></div><div class="bg bg3"></div>
        <div class="blocks">
        <div class="title">
          <h1>Sam <span>Harmonix</span></h1>
        </div>
        <div class="content">
          <div class="grid">
            <div class="wide"><a href="https://music.apple.com/us/artist/sam-harmonix/456290896"><i class="fab fa-itunes-note"></i> <h2>Listen on Apple Music</h2></a></div>
            <div><a href="https://music.youtube.com/channel/UCsDdoC9NhqxTaL7uuYn0j0Q"><i class="fas fa-play-circle"></i></a></div>
            <div><a href="https://m.soundcloud.com/samharmonix"><i class="fab fa-soundcloud"></i></a></div>
            <div><a href="https://www.deezer.com/us/artist/4837914"><i class="fab fa-deezer"></i></a></div>

            <div class="wide"><a href="https://open.spotify.com/artist/5eXdz9LJNkDuttYIR4t1Y4?si=Jc5Gr-quTAuGSEWk0TTgFA"><i class="fab fa-spotify"></i> <h2>Listen on Spotify</h2></a></div>

            <div><a href="https://tidal.com/artist/5206669"><img src="@/assets/icons/tidal.png"/></a></div>
            <div><a href="https://pandora.app.link/s5xjrdM0Y9"><img src="@/assets/icons/pandora.png"/></a></div>
            <div><a href="https://www.iheart.com/artist/sam-harmonix-733640/"><img src="@/assets/icons/iheart.png"/></a></div>
            <div class="wide"><a href="https://www.youtube.com/channel/UCablFopYgLI7l_fq9hmqNYw"><i class="fab fa-youtube"></i> <h2>Watch Youtube Videos</h2></a></div>


          </div>
        </div>
        </div>
        </div>
  </div>
</template>

<script>
import Block from "./Block";
import $ from "jquery";

export default {
  name: 'HelloWorld',
  components : {
    Block
  },
  props: {
  },
  methods: {
    animateIcons: function(delay) {
       this.icons = $(".grid div");
       this.iconIndex = 0;
      this.iconAniDelay = delay;
       setTimeout(this.animateNext(), delay);
    },
    animateNext: function() {
      if(this.iconIndex > this.icons.length) {
        return;
      }

      var icon = this.icons[this.iconIndex];
      this.animateIcon(icon);
      this.iconIndex++;
      setTimeout(this.animateNext, this.iconAniDelay);
    },
    animateIcon: function(icon) {
      var icon = $(icon);
      icon.addClass("magictime spaceInDown")
    },
    resize: function() {

        $(".grid div").each(function() {
        if($(this).hasClass("wide")) {
          return;
        }

        $(this).height($(this).width());
      });
    },
    addBackground: function() {
      setTimeout(this.activateBackground, 500);
    },
    activateBackground: function() {
      $(".bg").each(function() {
        $(this).addClass("active");
      });
    },
    ready: function() {
      this.resize();
      $(window).on("resize", this.resize());

      setTimeout(this.addBackground, 500);
      $(".title").first().addClass("magictime spaceInUp");
      $(".grid").first().addClass("magictime spaceInDown");
      this.animateIcons(150);
    }
  },
  mounted: function() {
    $(document).ready(this.ready);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
 .bg {
  background-image: linear-gradient(-60deg, red 50%, white 50%);
  bottom:0;
  left:-50%;
  position:fixed;
  right:-50%;
  top:0;
  z-index:-1;

  opacity: 0;
  transition: 1s ease;
}

  .bg.active {
      opacity: .5;

    animation:slide 9s ease-in-out infinite alternate;
  }

.bg2.active{
    opacity: .5;

  animation-direction:alternate-reverse;
  animation-duration:12s;
}

.bg3.active {
    opacity: .5;

  animation-duration:15s;
}




@keyframes slide {
  0% {
    transform:translateX(-25%);
  }
  100% {
    transform:translateX(25%);
  }
}

.page {
  padding: 25px;
  padding-bottom: 50px;
}
  .blocks {
    transform: scale(.8);

  }
  .hello {
background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
	background-size: 400% 400%;
	animation: gradient 10s ease-in infinite;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1 {
    font-size: 37px;
    background-color: white;
    padding-left: 8px;
    box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.017),
  0 6.7px 5.3px rgba(0, 0, 0, 0.024),
  0 12.5px 10px rgba(0, 0, 0, 0.03),
  0 22.3px 17.9px rgba(0, 0, 0, 0.036),
  0 41.8px 33.4px rgba(0, 0, 0, 0.043),
  0 100px 80px rgba(0, 0, 0, 0.06);
  }

  .title {
    font-weight: bolder;
    text-transform: uppercase;
    text-align: center;
    transform: skewX(-9deg);
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
  }

  .title span {
    background-color: black;
    color: white;
    padding-left: 5px;
    padding-right: 5px;
  }
  .content {
    max-width: 400px;
    margin: 0 auto;
  }

  .grid {
    display: grid;
    grid-gap: 1px;
    grid-template-columns: repeat(3, 1fr);
  }

  .grid div {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    font-size: 2.5em;
    background-color: white;
    margin: 10px;
     box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.017),
  0 6.7px 5.3px rgba(0, 0, 0, 0.024),
  0 12.5px 10px rgba(0, 0, 0, 0.03),
  0 22.3px 17.9px rgba(0, 0, 0, 0.036),
  0 41.8px 33.4px rgba(0, 0, 0, 0.043),
  0 100px 80px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: .5s ease;
  }

  .grid .wide {
    grid-column-start: 1;
    grid-column-end: 4;
  }

  .grid div h2 {
    font-size: 14px;
    margin: 25px;
  }

  .grid div:hover {
    filter: brightness(103%);
  }

  a {
    padding: 10px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: inherit;
  }

  a img {
    width: 50%;
    height: auto;
  }

</style>
